import React, { useState, useEffect, forwardRef } from 'react';
import { motion } from 'framer-motion';

const steps = [
  { num: '01', title: 'Browse', desc: 'Find vetted professionals' },
  { num: '02', title: 'Connect', desc: 'Schedule a free consultation' },
  { num: '03', title: 'Grow', desc: 'Focus on your business' },
];

export const Scene4 = forwardRef(function Scene4(props, ref) {
  const [phase, setPhase] = useState(0);

  useEffect(() => {
    const timers = [
      setTimeout(() => setPhase(1), 300),
      setTimeout(() => setPhase(2), 1100),
      setTimeout(() => setPhase(3), 1900),
    ];
    return () => timers.forEach(t => clearTimeout(t));
  }, []);

  return (
    <motion.div
      ref={ref}
      className="absolute inset-0 flex flex-col items-center justify-center"
      initial={{ x: '100%', opacity: 0 }}
      animate={{ x: '0%', opacity: 1 }}
      exit={{ x: '-100%', opacity: 0 }}
      transition={{ duration: 0.8, ease: [0.16, 1, 0.3, 1] }}
    >
      <motion.h2
        className="text-5xl font-bold mb-16 text-[#004D35]"
        style={{ fontFamily: 'Playfair Display, serif' }}
        initial={{ opacity: 0, y: -20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6, delay: 0.1 }}
      >
        How it works
      </motion.h2>

      <div className="flex items-start justify-center gap-12 max-w-5xl w-full px-8">
        {steps.map((step, i) => (
          <motion.div
            key={i}
            className="flex-1 text-center"
            initial={{ opacity: 0, y: 30 }}
            animate={phase >= (i + 1) ? { opacity: 1, y: 0 } : { opacity: 0, y: 30 }}
            transition={{ type: 'spring', stiffness: 100, damping: 20 }}
          >
            <div
              className="w-20 h-20 mx-auto rounded-full bg-[#0D6B4B] text-white flex items-center justify-center text-3xl font-bold mb-6 shadow-lg"
              style={{ fontFamily: 'Playfair Display, serif', boxShadow: '0 8px 30px rgba(13,107,75,0.3)' }}
            >
              {step.num}
            </div>
            <h3 className="text-2xl font-bold text-[#004D35] mb-2">{step.title}</h3>
            <p className="text-gray-500 text-sm">{step.desc}</p>
          </motion.div>
        ))}
      </div>

      <motion.div
        className="flex items-center gap-3 mt-12"
        initial={{ opacity: 0 }}
        animate={phase >= 3 ? { opacity: 1 } : { opacity: 0 }}
        transition={{ duration: 0.8 }}
      >
        <div className="h-px w-12 bg-[#C5A431]" />
        <span className="text-sm text-[#C5A431] font-semibold tracking-widest uppercase">Free to get started</span>
        <div className="h-px w-12 bg-[#C5A431]" />
      </motion.div>
    </motion.div>
  );
});
